import { useObservable, useSubscription } from "observable-hooks";
import React, { useContext } from "react";
import { EMPTY } from "rxjs";
import { filter, mergeMap } from "rxjs/operators";

import { NaviContext } from "../contexts/navi";
import { auth } from "../firebase";
import { store as storeRefreshTokens } from "../stores/refresh-tokens";

export default function RefreshTokenLayout({ children: content }) {
  const {
    context: { user },
  } = useContext(NaviContext);

  const refreshUserToken$ = useObservable(
    (input$) =>
      input$.pipe(
        filter(([user]) => user != null),
        mergeMap(([user]) => storeRefreshTokens.getByUserId(user.uid)),
        filter((doc) => doc != null),
        mergeMap(() => auth.currentUser ? auth.currentUser.getIdToken(true) : EMPTY),
        mergeMap(() => auth.currentUser ? storeRefreshTokens.delete(auth.currentUser.uid) : EMPTY)
      ),
    [user]
  );

  useSubscription(refreshUserToken$);

  return <React.Fragment>{content}</React.Fragment>;
}
